<template>
  <form @submit.prevent="handleSubmit">
    <div v-if="!showMessage || (!submitted && showMessage)">
      <slot />
      <div
        style="position: absolute; left: -5000px;"
        aria-hidden="true"
      >
        <input
          ref="hiddenField"
          :name="hiddenFieldId"
          type="text"
          :tabindex="-1"
          value=""
        >
      </div>
      <button class="footer__email-button">
        <slot name="button" />
      </button>
      <input
        id="mc-embedded-subscribe"
        type="submit"
        value="Subscribe"
        name="subscribe"
        style="position: absolute; left: -9999px; width: 1px; height: 1px;"
        :tabindex="-1"
      >
    </div>
    <p
      v-if="submitted && showMessage"
      class="submit-message"
      v-text="message"
    />
  </form>
</template>

<script>
export default {
  props: {
    hiddenFieldId: {
      type: String,
      default: '',
    },
    showMessage: {
      type: Boolean,
      default: false,
    },
    ajaxUrl: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      message: 'Thanks for subscribing to our newsletter!',
      submitted: false,
    }
  },
  methods: {
    async handleSubmit({ target }) {
      const submitUrl = target.getAttribute('action')
      const params = new URLSearchParams(submitUrl)
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const email = document.getElementById('mce-EMAIL').value
      const list_id = params.get('id')

      if (!this.showMessage) {
        target.submit()
      }

      if (!email.match(emailRegex)) {
        return
      }

      try {
        const response = await fetch('/wp-admin/admin-ajax.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
          },
          body: 'action=mailchimp&' + new URLSearchParams({
            list_id,
            email,
            [this.hiddenFieldId]: this.$refs.hiddenField.value,
          }).toString(),
        })

        this.submitted = response.ok
      } catch (err) {
        // console.error(err)
      }
    },
  },
}
</script>
